import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useAuth0 } from '@auth0/auth0-react';

const PrivateRoute = ({ children, ...rest }) => {
	const { isAuthenticated, isLoading } = useAuth0();

	return (
		<Route
			{...rest}
			render={({ location }) =>
				isAuthenticated || isLoading ? (
					children
				) : (
					<Redirect
						to={{
							pathname: '/login',
							state: { from: location },
						}}
					/>
				)
			}
		/>
	);
};

PrivateRoute.propTypes = {
	children: PropTypes.node.isRequired,
};

export default PrivateRoute;
